<template>
    <div class="YUploadImage">
        <div class="YUploadImage-set" ref="viewerImage">
            <div
                v-if="value[propsObj._key] || propsObj._default"
                :class="['YUploadImage-set-img', isAvatar ? 'YUploadImage-set-avatar' : '']"
                :style="{
                    backgroundImage: `url(${$imageResize(value[propsObj._key] || propsObj._default, imageResizeConfig)})`,
                    borderRadius: propsObj.radius ? '50%' : ''
                }"
            >
                <img :data-original="value[propsObj._key]" style="display:none">
                <div v-if="value[propsObj._key] && propsObj._canAction" class="YUploadImage-set-action">
                    <Icon class="YUploadImage-set-img-action" type="ios-eye-outline" size="16" @click.native="handlePreview"></Icon>
                    <Icon class="YUploadImage-set-img-action" type="ios-trash-outline" size="16" @click.native="handleRemove"></Icon>
                </div>
            </div>
            <div class="wrap">
                <Button type="default" class="btn-cancel-outline z-default">点击上传</Button>
                <input id="fileupload" class="file" :type="inputType" @change="setImage" />
            </div>
        </div>

        <!-- 修改头像模态框 -->
        <Modal
            :title="propsObj._title || '修改头像'"
            v-model="avatarModal"
            class="bri-modal"
            width="500"
            :mask-closable="false"
            :footer-hide="true"
            @on-visible-change="visibleChange"
        >
            <div class="avatar-modal" style="width:400px;margin: 0 auto;">
                <dsh-cropper
                    style="width: 400px;height: 400px;"
                    ref="cropper"
                    :src="imgSrc"
                    alt="Source Image"
                    :cropmove="cropImage"
                >
                </dsh-cropper>
                <div class="avatar-modal-footer bri-footer">
                    <Button @click="cancelAvatarModal()">取消</Button>
                    <Button type="primary" @click="photoSubmit()">保存</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    import uploadMixin from "./uploadMixin.js";
    import Viewer from "viewerjs";

    export default {
        name: "YUploadImage",
        mixins: [uploadMixin],
        components: {},
        props: {
            value: Object,
            propsObj: Object,
            requestOssType: { // 上传的是阿里云还是本地
                type: String,
                default: "default"
            },
            isAvatar: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                // 头像
                avatarModal: false,
                inputType: "file",
                imgSrc: "",
                cropImg: ""
            };
        },
        computed: {
            imageResizeConfig () {
                return this.propsObj._imageResizeConfig || {
                    m: "fixed",
                    w: 100,
                    h: 100
                };
            },
            finalRequestOssType () {
                return this.propsObj._requestOssType || this.requestOssType || "default";
            }
        },
        created () {
        },
        methods: {
            // 打开修改头像
            openAvatar () {
                this.avatarModal = true;
            },
            // 关闭修改头像
            cancelAvatarModal () {
                this.avatarModal = false;
                // this.inputType = "file";
            },
            // 头像模态框状态变化，关闭后改变input框类型，保证上传能够连续上传同一张图片
            visibleChange (bool) {
                if (!bool) {
                    this.inputType = "file";
                }
            },
            setImage (e) {
                if (e.target.files.length != 0) {
                    const file = e.target.files[0];
                    if (!file.type.includes("image/")) {
                        this.$Message.error("请选择一张图片");
                        return;
                    }
                    if (typeof FileReader === "function") {
                        const reader = new FileReader();
                        if (this.propsObj._kind == "uploadImage") {
                            reader.onload = (event) => {
                                let data = event.target.result;
                                this.inputType = "text";
                                if (this.finalRequestOssType === "local") {
                                    // base64转文件
                                    const imgFile = this.dataURLtoFile(data, "");
                                    this.handlePost(imgFile);
                                } else {
                                    data = data.split(",")[1];
                                    let dataBuffer = Buffer.from(data, "base64");
                                    this.handlePost(dataBuffer);
                                }
                            };
                            reader.readAsDataURL(file);
                        } else {
                            reader.onload = (event) => {
                                this.imgSrc = event.target.result;
                                // rebuild cropperjs with the updated source
                                this.$refs.cropper.replace(event.target.result);
                                this.inputType = "text";
                            };
                            reader.readAsDataURL(file);
                            this.avatarModal = true;
                        }
                    } else {
                        alert("Sorry, FileReader API not supported");
                    }
                }
            },
            cropImage () {
                // get image data for post processing, e.g. upload or setting image src
                this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
            },
            // 获取裁剪后的图片，转成file
            photoSubmit () {
                this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
                if (this.finalRequestOssType === "local") {
                    // base64转文件
                    const imgFile = this.dataURLtoFile(this.cropImg, "");
                    this.handlePost(imgFile);
                } else {
                    let data = this.cropImg;
                    data = data.split(",")[1];

                    let dataBuffer = Buffer.from(data, "base64");
                    this.handlePost(dataBuffer);
                }

                this.cancelAvatarModal();
            },
            // 将图片Base64 转成文件
            dataURLtoFile (dataurl, filename) {
                // 获取文件扩展名称
                let arr = dataurl.split(",");
                let mime = arr[0].match(/:(.*?);/)[1];
                let extension = mime.split("/")[1];
                let bstr = atob(arr[1]);
                let n = bstr.length;
                let u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], `${filename}.${extension}`, {type: mime});
            },
            handleSuccess (response, res) {
                this.value[this.propsObj._key] = res.data.downloadUrl;
                this.$emit("change", res);
            },
            handleError (err) {
                alert(err);
            },
            // 点击文件预览
            handlePreview (file) {
                let viewerImage = this.$refs.viewerImage;
                let viewer = new Viewer(viewerImage, {
                    url: "data-original",
                    hidden: function () {
                        viewer.destroy();
                    },
                    loop: false,
                    zIndex: 2147483647
                });
                viewer.show();
            },
            // 点击文件删除 - fileList服务器的数据列表
            handleRemove (file) {
                this.inputType = "file"; // 删除后可以重新上传
                this.value[this.propsObj._key] = "";
                this.change(this.value);
            },
            change (...params) {
                this.$emit("change", ...params);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/ZUpload/YUploadImage.vue